import React, { FC } from 'react';
import { Box, EmptyState, TextButton } from '@wix/design-system';
import { Refresh } from '@wix/wix-ui-icons-common';
import { useTranslation } from '@wix/fe-essentials-standalone';

type Props = { overrideAction?: () => void };

const TechnicalErrorState: FC<Props> = ({ overrideAction }) => {
  const { t } = useTranslation();

  function reloadPage() {
    window.location.reload();
  }

  return (
    <Box align="center" verticalAlign="middle" width="100%" height="100%">
      <EmptyState
        dataHook="template-technical-error-state"
        theme="page-no-border"
        title={t('marketplace.template-technical-error-title')}
        subtitle={t('marketplace.template-technical-error-subtitle')}
      >
        <TextButton
          prefixIcon={<Refresh />}
          onClick={!!overrideAction ? overrideAction : reloadPage}
        >
          {t('marketplace.template-technical-error-cta')}
        </TextButton>
      </EmptyState>
    </Box>
  );
};

export default TechnicalErrorState;
